import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppInput from '@nxsys/components/AppInput';
import AppSelectSync from '@nxsys/components/AppSelectSync';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Option } from '@nxsys/types/models/Common';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import React, { Ref, useImperativeHandle } from 'react';

type ExpenseFormProps = {
  formRef?: Ref<ExpenseFormRef>;
  onSubmit?: (values: ExpenseValues) => Promise<void>;
  defaultValues?: Partial<ExpenseValues>;
};

export type ExpenseFormRef = {
  submit: () => void;
  reset: () => void;
};

export type ExpenseValues = {
  expenseCode: string;
  expenseName: string;
  vatCodeId: Option<string> | null;
};

const ExpenseForm: React.FC<ExpenseFormProps> = ({
  formRef,
  onSubmit,
  defaultValues = {},
}) => {
  const { messages } = useTypedIntl();

  const [form] = Form.useForm<ExpenseValues>();

  useImperativeHandle(formRef, () => ({
    submit() {
      form.submit();
    },
    reset() {
      form.resetFields();
    },
  }));

  const onFinish: FormProps['onFinish'] = async (values) => {
    await onSubmit?.(values);
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppFormContainer
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      initialValues={defaultValues}
    >
      <Form.Item
        label={messages['common.expenseCode']}
        name="expenseCode"
        rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
      >
        <AppInput placeholder={messages['form.enter']} />
      </Form.Item>
      <Form.Item
        label={messages['common.expenseName']}
        name="expenseName"
        rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
      >
        <AppInput placeholder={messages['form.enter']} />
      </Form.Item>
      <Form.Item name="vatCodeId" label={messages['common.vatCode']}>
        <AppSelectSync
          type="VATCode"
          apiType="searchVATCode"
          placeholder={messages['assignment.rate.selectVatRate']}
          style={{ width: '100%' }}
          onChangeValue={(value: any) => {
            form.setFieldValue('vatCodeId', value);
          }}
        />
      </Form.Item>
    </AppFormContainer>
  );
};

export default ExpenseForm;
